module.exports = __webpack_public_path__ + "images/0e05d49f71699798ef80278bd7fd05b7b966197c57e46855cfd0e01b3cefb98c.svg";